import { axiosClient } from '../axiosClient';
import type {
  Plano,
  PlanoInput,
  Assinatura,
  GrantSubscriptionInput,
  UserSubscriptionResponse,
  FuncionarioVinculo,
} from '@/types/subscription.types';

// ----- Planos (catálogo) -----

export const getPlans = async (): Promise<Plano[]> => {
  try {
    const response = await axiosClient.get('/admin/plans');
    return response.data.planos;
  } catch (error) {
    console.error('Failed to fetch plans:', error);
    throw error;
  }
};

// Dias de trial configurados (`system_settings.subscription.trial_days`).
// Fonte única — nunca hardcode esse número numa tela.
export const getTrialDays = async (): Promise<number> => {
  try {
    const response = await axiosClient.get('/admin/plans');
    return response.data.trialDays;
  } catch (error) {
    console.error('Failed to fetch trial days:', error);
    throw error;
  }
};

export const createPlan = async (data: PlanoInput): Promise<Plano> => {
  try {
    const response = await axiosClient.post('/admin/plans', data);
    return response.data.plano;
  } catch (error) {
    console.error('Failed to create plan:', error);
    throw error;
  }
};

export const updatePlan = async (id: number, data: PlanoInput): Promise<Plano> => {
  try {
    const response = await axiosClient.patch(`/admin/plans/${id}`, data);
    return response.data.plano;
  } catch (error) {
    console.error(`Failed to update plan ${id}:`, error);
    throw error;
  }
};

// ----- Assinatura por usuário -----

export const getUserSubscription = async (
  userId: string | number
): Promise<UserSubscriptionResponse> => {
  try {
    const response = await axiosClient.get(`/admin/users/${userId}/subscription`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch subscription for user ${userId}:`, error);
    throw error;
  }
};

// Grant simplificado: aplica um dos 6 tipos (5 padrão de 1 clique + custom).
// Backend resolve datas/limites dos tipos padrão; custom envia o form completo.
export const grantSubscription = async (
  userId: string | number,
  data: GrantSubscriptionInput
): Promise<Assinatura> => {
  try {
    const response = await axiosClient.post(`/admin/users/${userId}/subscription/grant`, data);
    return response.data.assinatura;
  } catch (error) {
    console.error(`Failed to grant subscription for user ${userId}:`, error);
    throw error;
  }
};

export const getUserFuncionarios = async (
  userId: string | number
): Promise<FuncionarioVinculo[]> => {
  try {
    const response = await axiosClient.get(`/admin/users/${userId}/funcionarios`);
    return response.data.funcionarios;
  } catch (error) {
    console.error(`Failed to fetch funcionarios for user ${userId}:`, error);
    throw error;
  }
};
